import { createGlobalStyle } from 'styled-components';
import { colorVarNames, fontVarNames } from 'voyager';

export const VoyagerThemeBridge = createGlobalStyle`
  :root {
    ${colorVarNames.primary}: ${({ theme }) => theme.customColors.primary};
    ${colorVarNames.secondary}: ${({ theme }) => theme.customColors.secondary};
    ${colorVarNames.tertiary}: ${({ theme }) => theme.customColors.tertiary};
    ${colorVarNames.navigationAndFooter}: ${({ theme }) => theme.customColors.navigationAndFooter};
    ${colorVarNames.header}: ${({ theme }) => theme.customColors.header};
    ${colorVarNames.sectionTitle}: ${({ theme }) => theme.customColors.sectionTitle};
    ${colorVarNames.borderGrey}: ${({ theme }) => theme.customColors.borderGrey};
    ${colorVarNames.borderGreyLighter}: ${({ theme }) => theme.customColors.borderGreyLighter};

    ${colorVarNames.fontPrimary}: ${({ theme }) => theme.defaultColors.fontPrimary};
    ${colorVarNames.fontSecondary}: ${({ theme }) => theme.defaultColors.fontSecondary};
    ${colorVarNames.darkGrey}: ${({ theme }) => theme.defaultColors.darkGrey};
    ${colorVarNames.grey}: ${({ theme }) => theme.defaultColors.grey};
    ${colorVarNames.lightGrey}: ${({ theme }) => theme.defaultColors.lightGrey};
    ${colorVarNames.lighterGrey}: ${({ theme }) => theme.defaultColors.lighterGrey};
    ${colorVarNames.error}: ${({ theme }) => theme.defaultColors.error};
    ${colorVarNames.errorBackground}: ${({ theme }) => theme.defaultColors.errorBackground};
    ${colorVarNames.success}: ${({ theme }) => theme.defaultColors.success};
    ${colorVarNames.successBackground}: ${({ theme }) => theme.defaultColors.successBackground};
    ${colorVarNames.info}: ${({ theme }) => theme.defaultColors.info};
    ${colorVarNames.infoBackground}: ${({ theme }) => theme.defaultColors.infoBackground};
    ${colorVarNames.black}: ${({ theme }) => theme.defaultColors.black};
    ${colorVarNames.white}: ${({ theme }) => theme.defaultColors.white};
    ${colorVarNames.offWhite}: ${({ theme }) => theme.defaultColors.offWhite};
    ${colorVarNames.sale}: ${({ theme }) => theme.defaultColors.sale};

    ${fontVarNames.heading}: ${({ theme }) => theme.headerFont}, serif;
    ${fontVarNames.body}: ${({ theme }) => theme.bodyFont}, sans-serif;
  }
`;
